export const fleetTaskFields = [
  {
    label: 'ID',
    key: 'row_id.value',
    isSortable: false,
  },
  {
    label: 'Nomor Penugasan',
    key: 'fleet_task_number',
  },
  {
    label: 'global.field.shipmentReference',
    key: 'shipment_reference.value',
  },
  {
    label: 'Keberangkatan',
    key: 'expected_departure_on.value',
    type: 'date',
  },
  {
    label: 'Titik Mulai',
    key: 'start_address_name.value',
  },
  {
    label: 'Titik Akhir',
    key: 'end_address_name.value',
  },
  {
    label: 'Plat Nomor',
    key: 'license_plate.value',
  },
  {
    label: 'Pengemudi',
    key: 'driver_user_name.value',
  },
  {
    label: 'Durasi Pickup',
    key: 'pickup_service_time.value',
  },
  {
    label: 'Durasi Drop',
    key: 'drop_service_time.value',
  },
].map((field) => ({
  ...field,
  isSortable: field.key === 'row_id.value' ? false : true,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:190px;',
  },
}))

export const deliveryOrderFields = [
  {
    label: 'ID',
    key: 'row_id.value',
    isSortable: false,
  },
  {
    label: 'No. Pengiriman',
    key: 'number',
  },
  {
    label: 'Nama Pelanggan',
    key: 'customer.value',
  },
  {
    label: 'Karyawan Pemasaran',
    key: 'marketing_user.value',
  },
  {
    label: 'Target Diambil',
    key: 'expected_pickup_on.value',
  },
  {
    label: 'Target Dikirim',
    key: 'expected_delivered_on.value',
  },
  {
    label: 'No. AJU',
    key: 'aju_number.value',
  },
  {
    label: 'No. Shipment',
    key: 'shipment_number.value',
  },
  {
    label: 'No. Referensi',
    key: 'reference_number.value',
  },
  {
    label: 'Catatan Lainnya',
    key: 'note.value',
  },
  {
    label: 'Alamat Asal',
    key: 'origin_address.value',
  },
  {
    label: 'Alamat Tujuan',
    key: 'destination_address.value',
  },
  {
    label: 'Jenis Box',
    key: 'box_type.value',
  },
  {
    label: 'Penugasan ID',
    key: 'row_fleet_task_id.value',
  },
].map((field) => ({
  ...field,
  isSortable: field.key === 'row_id.value' ? false : true,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}))

export const loadFields = [
  {
    label: 'ID',
    key: 'row_id.value',
    isSortable: false,
  },
  {
    label: 'Nama Produk',
    key: 'product.value',
  },
  {
    label: 'Kuantitas',
    key: 'quantity.value',
  },
  {
    label: 'Satuan Kuantitas',
    key: 'uom.value',
  },
  {
    label: 'Catatan',
    key: 'note.value',
  },
].map((field) => ({
  ...field,
  isSortable: field.key === 'row_id.value' ? false : true,
  showErrorKey: field.key.replace('.value', ''),
  thAttr: {
    style: 'min-width:180px;',
  },
}))
